import { render, staticRenderFns } from "./Pagos.vue?vue&type=template&id=049ea01f&scoped=true&"
import script from "./Pagos.vue?vue&type=script&lang=ts&"
export * from "./Pagos.vue?vue&type=script&lang=ts&"
import style0 from "./Pagos.vue?vue&type=style&index=0&id=049ea01f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049ea01f",
  null
  
)

export default component.exports